module.exports = __webpack_public_path__ + "static/media/alien-monster.167c12a8.svg";